<template>
  <div class="select-box">
    <div
      ref="selectionHolder"
      class="select-holder"
    >
      <img
        :src="require('@/assets/svg/SVG/unchecked_circle.svg')"
        alt="Download"
      >
      <img
        :src="require('@/assets/svg/SVG/checked_circle.svg')"
        alt="Download"
      >
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';

export default {
  name: 'SelectionMarker',
  methods: {
    selected () {
      gsap.to(this.$refs.selectionHolder, {
        y:-32,
        duration: 0
      });
    },
    unselected () {
      gsap.to(this.$refs.selectionHolder, {
        y:0,
        duration: 0
      });
    }
  }
};
</script>

<style scoped>
.select-box {
  cursor: pointer;
  width: 25px;
  height: 25px;
  border-radius: 25px;
  overflow: hidden;
}
</style>